import { Component, OnInit } from '@angular/core';

import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { HTTPService } from 'app/services/http.service';
import { HelperService } from 'app/services/helper.service';
import { FormatService } from 'app/services/format.service';
import { ValidationService, DataService } from 'app/services';

@Component({
  selector: 'app-custom-fleet-pricing',
  templateUrl: './custom-fleet-pricing.component.html',
  styleUrls: ['./custom-fleet-pricing.component.scss'],
})
export class CustomFleetPricingComponent implements OnInit {
  user: any;
  isLoading: boolean = false;
  isSubmitting: boolean = false;
  fleetSettings: any = {
    isOrderDiscOverride: false,
    isShopSuppliesOverride: false,
    isLaborRateOverride: false,
    isPricingMatrixOverride: false,
    isPartPricingMatrixOverride: false,
    isTirePricingMatrixOverride: false,
    customLaborRate: null,
    customPartPricingMatrix: null,
    customTirePricingMatrix: null,
    customShopSuppliesType: null,
    customShopSuppliesValue: '',
    customShopSuppliesCap: '',
    customOrderDiscountType: null,
    customOrderDiscountValue: '',
    customOrderDiscountCap: '',
    useDriverDetailOnInvoice: false
  };
  errors: any = {};

  constructor(
    private formatService: FormatService,
    private helperService: HelperService,
    private dynamicDialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    private httpService: HTTPService,
    private validationService: ValidationService,
    private dataService: DataService,
  ) { }

  ngOnInit() {
    this.user = this.dialogConfig.data ? this.dialogConfig.data : null;

    if (this.user && this.user._id) {
      this.getCustomer();
    }
  }

  getCustomer() {
    this.isLoading = true;
    this.httpService
      .getCustomer(this.user._id)
      .then((customer: any) => {
        this.user = customer;
        this.isLoading = false;
      })
      .catch((err) => {
        this.helperService.showToaster('error', err);
      });
  }

  closeDialog(data?: any) {
    this.dynamicDialogRef.close(data);
  }

  updateFleetSettings({ fleetSettings }) {
    this.fleetSettings = fleetSettings;
  }

  handleSubmit() {
    if (!this.validationService.validateCustomFleetSettings(this.fleetSettings, this.errors)) return;

    this.isSubmitting = true;
    this.httpService
      .updateCustomerFleetSettings(this.user._id, this.formatService.formatFleetSettings(this.fleetSettings))
      .then(
        (customer) => {
          customer.customLaborRate = this.fleetSettings.customLaborRate;
          customer.customPartPricingMatrix = this.fleetSettings.customPartPricingMatrix;
          customer.customTirePricingMatrix  = this.fleetSettings.customTirePricingMatrix;
          customer.customTaxCode = this.fleetSettings?.customTaxCode;

          this.dataService.sendData(
            this.dataService.typeFleetOverride('close', null, null, {
              isSuccess: true,
              customer: { 
                _id: customer._id, 
                useDriverDetailOnInvoice: customer.useDriverDetailOnInvoice 
              },
              type: 'fleet-override',
            }),
          );

          this.closeDialog(customer);
          this.helperService.showToaster('success', 'Successfully updated');
        },
        (err) => {
          this.helperService.showToaster('error', err);
        }
      )
      .finally(() => {
        this.isSubmitting = false;
      });
  }
}
